import {ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild,} from '@angular/core';
import {MatTable, MatTableDataSource} from '@angular/material/table';
import {FormGroup} from '@angular/forms';
import {icons} from 'src/app/ui/icons';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

type Column = keyof any;

@Component({
    selector: 'app-detail-agrement',
    templateUrl: './detail-agrement.component.html',
    styleUrls: ['./detail-agrement.component.css'],
})
export class DetailAgrementComponent implements OnInit {
    t: any;
    @ViewChild(MatTable, {static: true}) table: MatTable<any>;
    @Output() next = new EventEmitter<any>();
    tableForm: FormGroup;
    displayedColumns: Column[] = [
        'licenseNm',
        'licenseCd',
        'licenseRegNo',
        'issuedInst',
        'issuedYmd',
        'expirationYmd',
    ];
    dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    labels: Partial<Record<Column, string>> = {
        licenseNm: 'Classification de l\'agrément',
        licenseCd: 'Agrément ',
        licenseRegNo: 'N° d\'enregistrement de(s) agrément(s)',
        issuedInst: 'Institution de délivrance',
        issuedYmd: 'Date de l\'obtention',
        expirationYmd: 'Date d\'expiration',
    };
    displayedColumnss: (Column | 'N')[] = ['N', ...this.displayedColumns];
    icons = icons;
    Ussine: any[] = [];

    constructor(
        private dialogRef: MatDialogRef<DetailAgrementComponent, { data: any }>,
        private cdref: ChangeDetectorRef,
        @Inject(MAT_DIALOG_DATA) data: { t: any }
    ) {
        this.t = data;
    }

    ngOnInit(): void {
        this.Ussine.push(this.t);

        this.dataSource.data = this.Ussine;
    }
}
